const State = {
  stockMoveList: [],
  stockMoveReasonList: [],
  maxSortNumber: 0
}

export default State
